import React from 'react'
import { ClassNames } from '@emotion/react'

const mitLibraries = [
    `Classcat is copyright (c) 2017 – Present Jorge Bucaran`,
    `Dayjs is copyright (c) 2018 iamkun`,
    `ES6 is copyright (c) 2015 Nicolas Bevacqua`,
    `ES-6 Symbol is copyright (c) 2013-2015 Mariusz Nowak (www.medikoo.com)`,
    `Material- UI is copyright (c) 2014 Call-Em-All`,
    `Moment is copyright (c) JS Foundation and other contributors`,
    `React is copyright (c) 2013-present, Facebook, Inc.`,
    `React Dom is copyright (c) 2013-present, Facebook, Inc.`,
    `React-input-mask is copyright (c) 2016 Nikita Lobachev`,
    `React Redux is copyright (c) 2015-present Dan Abramov`,
    `React Render is copyright (c) 2015 Mark Finger`,
    `React Router Dom is copyright (c) 2016-2017 React Training`,
    `React SVG is copyright (c) 2015 Maxime Thirouin`,
    `React Tap Event Plugin is copyright (c) 2014-2015 Zilverline B.V.`,
    `Redux is copyright (c) 2015-present Dan Abramov`,
    `Redux Actions is copyright (c) 2016 Andrew Clark`,
    `Redux Promise Middleware is copyright (c) 2015 Patrick Burtchaell`,
    `SVGInjector is copyright (c) 2014-2015 Waybury`,
    `URL Search Params Polyfill is copyright (c) 2016 Jerry Bendy`
]

const bsdLibraries = [
    'Browser-locale ',
    'Draft.js is copyright (c) 2013-present, Facebook, Inc.',
    'Draft JS Export is copyright (c) 2016, Simon Sturmer <sstur@me.com>'
]

const apacheLibraries = [
    'Material/button is copyright (c) 2018 Google, Inc. ',
    'Material/checkbox (c) 2018 Google, Inc.'
]

export const License = () => (
    <ClassNames>
        {({ css }) => (
            <div
                className={css`
                    font-size: 1rem;
                    line-height: 1.5;
                    color: rgba(0, 0, 0, 0.54);

                    p {
                        margin-bottom: 1rem;
                    }
                `}>
                <DiligentStatement />
                <MitLicense />
                <BsdLicense />
                <ApacheLicense />
            </div>
        )}
    </ClassNames>
)

const DiligentStatement = () => (
    <section>
        <p>1. Diligent Intellectual Property</p>
        <p>
            “Diligent” is a trademark of Diligent Corporation, registered in the US Patent and
            Trademark Office. “Diligent Boardbooks” is a trademark of Diligent Corporation,
            registered in the US Patent and Trademark Office and in other countries. “Diligent
            Boards,” “Diligent Minutes,” and the Diligent logo are trademarks of Diligent
            Corporation. All other trademarks are the property of their respective owners. Except as
            otherwise set forth herein, Diligent Minutes application, Diligent Boards web portal,
            BoardEffect Web Portal and all associated documentation are © 2015 Diligent Corporation.
            All rights reserved.
        </p>
    </section>
)

const MitLicense = () => (
    <section>
        <p>2. Notices for Software Components Licensed Under the MIT License</p>
        <p>
            The Diligent Minutes application uses Classcat, Dayjs, ES6, ES-6 Symbol, Material-UI,
            Moment, React, React Dom, React-input-mask, React Redux, React Render, React Router Dom,
            React SVG, React Tap Event Plugin, Redux, Redux Actions, Redux Promise Middleware,
            SVGInjector, and URL Search Params Polyfill.
        </p>
        <ul>
            {mitLibraries.map((library, idx) => (
                <li key={`mit-${idx}`}>{library}</li>
            ))}
        </ul>
        <p>MIT License (full text)</p>
        <p>
            Permission is hereby granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use, copy, modify,
            merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject to the following
            conditions:
        </p>
        <p>
            The above copyright notice and this permission notice shall be included in all copies or
            substantial portions of the Software.
        </p>
        <p>
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
            INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
            LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT
            OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
            OTHER DEALINGS IN THE SOFTWARE.
        </p>
    </section>
)

const BsdLicense = () => (
    <section>
        <p>3. Notices for Software Components Licensed Under the BSD License</p>
        <p>The Diligent Minutes application uses Browser-locale, Draft.js and Draft JS Export.</p>
        <ul>
            {bsdLibraries.map((library, idx) => (
                <li key={`bsd-${idx}`}>{library}</li>
            ))}
        </ul>
        <p>BSD License (full text)</p>
        <p>
            Redistribution and use in source and binary forms, with or without modification, are
            permitted provided that the following conditions are met:
        </p>
        <ul>
            <li>
                1. Redistributions of source code must retain the above copyright notice, this list
                of conditions and the following disclaimer.
            </li>
            <li>
                2. Redistributions in binary form must reproduce the above copyright notice, this
                list of conditions and the following disclaimer in the documentation and/or other
                materials provided with the distribution.
            </li>
            <li>
                3. Neither the name of the copyright holder nor the names of its contributors may be
                used to endorse or promote products derived from this software without specific
                prior written permission.
            </li>
        </ul>
        <p>
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY
            EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL
            THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
            SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
            OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
            INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
            LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
            OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
        </p>
    </section>
)

const ApacheLicense = () => (
    <section>
        <p>4. Notices for Software Components Licensed Under the Apache 2.0 License</p>
        <p>The Diligent Minutes application uses Material/button and Material/checkbox.</p>
        <ul>
            {apacheLibraries.map((library, idx) => (
                <li key={`apache-${idx}`}>{library}</li>
            ))}
        </ul>
        <p>
            Apache License
            <br />
            <br />
            Version 2.0, January 2004
            <br />
            <br />
        </p>
        <p>{`http://www.apache.org/licenses`}</p>
        <p>TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION</p>
        <p>
            <strong>1. Definitions</strong>.
        </p>
        <p>
            "License" shall mean the terms and conditions for use, reproduction, and distribution as
            defined by Sections 1 through 9 of this document.
        </p>
        <p>
            "Licensor" shall mean the copyright owner or entity authorized by the copyright owner
            that is granting the License.
        </p>
        <p>
            "Legal Entity" shall mean the union of the acting entity and all other entities that
            control, are controlled by, or are under common control with that entity. For the
            purposes of this definition, "control" means (i) the power, direct or indirect, to cause
            the direction or management of such entity, whether by contract or otherwise, or (ii)
            ownership of fifty percent (50%) or more of the outstanding shares, or (iii) beneficial
            ownership of such entity.
        </p>
        <p>
            "You" (or "Your") shall mean an individual or Legal Entity exercising permissions
            granted by this License.
        </p>
        <p>
            "Source" form shall mean the preferred form for making modifications, including but not
            limited to software source code, documentation source, and configuration files.
        </p>
        <p>
            "Object" form shall mean any form resulting from mechanical transformation or
            translation of a Source form, including but not limited to compiled object code,
            generated documentation, and conversions to other media types.
        </p>
        <p>
            "Work" shall mean the work of authorship, whether in Source or Object form, made
            available under the License, as indicated by a copyright notice that is included in or
            attached to the work (an example is provided in the Appendix below).
        </p>
        <p>
            "Derivative Works" shall mean any work, whether in Source or Object form, that is based
            on (or derived from) the Work and for which the editorial revisions, annotations,
            elaborations, or other modifications represent, as a whole, an original work of
            authorship. For the purposes of this License, Derivative Works shall not include works
            that remain separable from, or merely link (or bind by name) to the interfaces of, the
            Work and Derivative Works thereof.
        </p>
        <p>
            "Contribution" shall mean any work of authorship, including the original version of the
            Work and any modifications or additions to that Work or Derivative Works thereof, that
            is intentionally submitted to Licensor for inclusion in the Work by the copyright owner
            or by an individual or Legal Entity authorized to submit on behalf of the copyright
            owner. For the purposes of this definition, "submitted" means any form of electronic,
            verbal, or written communication sent to the Licensor or its representatives, including
            but not limited to communication on electronic mailing lists, source code control
            systems, and issue tracking systems that are managed by, or on behalf of, the Licensor
            for the purpose of discussing and improving the Work, but excluding communication that
            is conspicuously marked or otherwise designated in writing by the copyright owner as
            "Not a Contribution."
        </p>
        <p>
            "Contributor" shall mean Licensor and any individual or Legal Entity on behalf of whom a
            Contribution has been received by Licensor and subsequently incorporated within the
            Work.
        </p>
        <p>
            <strong>
                2. Grant of Copyright License.
                <br />
            </strong>
            Subject to the terms and conditions of this License, each Contributor hereby grants to
            You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable
            copyright license to reproduce, prepare Derivative Works of, publicly display, publicly
            perform, sublicense, and distribute the Work and such Derivative Works in Source or
            Object form.
        </p>
        <p>
            <strong>
                3. Grant of Patent License.
                <br />
            </strong>
            Subject to the terms and conditions of this License, each Contributor hereby grants to
            You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except
            as stated in this section) patent license to make, have made, use, offer to sell, sell,
            import, and otherwise transfer the Work, where such license applies only to those patent
            claims licensable by such Contributor that are necessarily infringed by their
            Contribution(s) alone or by combination of their Contribution(s) with the Work to which
            such Contribution(s) was submitted. If You institute patent litigation against any
            entity (including a cross-claim or counterclaim in a lawsuit) alleging that the Work or
            a Contribution incorporated within the Work constitutes direct or contributory patent
            infringement, then any patent licenses granted to You under this License for that Work
            shall terminate as of the date such litigation is filed.
        </p>
        <p>
            <strong>
                4. Redistribution.
                <br />
            </strong>
            You may reproduce and distribute copies of the Work or Derivative Works thereof in any
            medium, with or without modifications, and in Source or Object form, provided that You
            meet the following conditions:
        </p>
        <ul>
            <li>
                a. You must give any other recipients of the Work or Derivative Works a copy of this
                License; and
            </li>
            <li>
                b. You must cause any modified files to carry prominent notices stating that You
                changed the files; and
            </li>
            <li>
                c. You must retain, in the Source form of any Derivative Works that You distribute,
                all copyright, patent, trademark, and attribution notices from the Source form of
                the Work, excluding those notices that do not pertain to any part of the Derivative
                Works; and
            </li>
            <li>
                d. If the Work includes a "NOTICE" text file as part of its distribution, then any
                Derivative Works that You distribute must include a readable copy of the attribution
                notices contained within such NOTICE file, excluding those notices that do not
                pertain to any part of the Derivative Works, in at least one of the following
                places: within a NOTICE text file distributed as part of the Derivative Works;
                within the Source form or documentation, if provided along with the Derivative
                Works; or, within a display generated by the Derivative Works, if and wherever such
                third-party notices normally appear. The contents of the NOTICE file are for
                informational purposes only and do not modify the License. You may add Your own
                attribution notices within Derivative Works that You distribute, alongside or as an
                addendum to the NOTICE text from the Work, provided that such additional attribution
                notices cannot be construed as modifying the License.
                <br />
                <br />
                You may add Your own copyright statement to Your modifications and may provide
                additional or different license terms and conditions for use, reproduction, or
                distribution of Your modifications, or for any such Derivative Works as a whole,
                provided Your use, reproduction, and distribution of the Work otherwise complies
                with the conditions stated in this License.
            </li>
        </ul>
        <p>
            <strong>
                5. Submission of Contributions.
                <br />
            </strong>
            Unless You explicitly state otherwise, any Contribution intentionally submitted for
            inclusion in the Work by You to the Licensor shall be under the terms and conditions of
            this License, without any additional terms or conditions. Notwithstanding the above,
            nothing herein shall supersede or modify the terms of any separate license agreement you
            may have executed with Licensor regarding such Contributions.
        </p>
        <p>
            <strong>
                6. Trademarks.
                <br />
            </strong>
            This License does not grant permission to use the trade names, trademarks, service
            marks, or product names of the Licensor, except as required for reasonable and customary
            use in describing the origin of the Work and reproducing the content of the NOTICE file.
        </p>
        <p>
            <strong>
                7. Disclaimer of Warranty.
                <br />
            </strong>
            Unless required by applicable law or agreed to in writing, Licensor provides the Work
            (and each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT
            WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without
            limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or
            FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for determining the
            appropriateness of using or redistributing the Work and assume any risks associated with
            Your exercise of permissions under this License.
        </p>
        <p>
            <strong>
                8. Limitation of Liability.
                <br />
            </strong>
            In no event and under no legal theory, whether in tort (including negligence), contract,
            or otherwise, unless required by applicable law (such as deliberate and grossly
            negligent acts) or agreed to in writing, shall any Contributor be liable to You for
            damages, including any direct, indirect, special, incidental, or consequential damages
            of any character arising as a result of this License or out of the use or inability to
            use the Work (including but not limited to damages for loss of goodwill, work stoppage,
            computer failure or malfunction, or any and all other commercial damages or losses),
            even if such Contributor has been advised of the possibility of such damages.
        </p>
        <p>
            <strong>
                9. Accepting Warranty or Additional Liability.
                <br />
            </strong>
            While redistributing the Work or Derivative Works thereof, You may choose to offer, and
            charge a fee for, acceptance of support, warranty, indemnity, or other liability
            obligations and/or rights consistent with this License. However, in accepting such
            obligations, You may act only on Your own behalf and on Your sole responsibility, not on
            behalf of any other Contributor, and only if You agree to indemnify, defend, and hold
            each Contributor harmless for any liability incurred by, or claims asserted against,
            such Contributor by reason of your accepting any such warranty or additional liability.
        </p>
        <p>END OF TERMS AND CONDITIONS</p>
        <p>APPENDIX: How to apply the Apache License to your work</p>
        <p>
            To apply the Apache License to your work, attach the following boilerplate notice, with
            the fields enclosed by brackets "[]" replaced with your own identifying information.
            (Don't include the brackets!) The text should be enclosed in the appropriate comment
            syntax for the file format. We also recommend that a file or class name and description
            of purpose be included on the same "printed page" as the copyright notice for easier
            identification within third-party archives.
        </p>
        <div>
            <p>
                Copyright [yyyy] [name of copyright owner]
                <br />
                <br />
                Licensed under the Apache License, Version 2.0 (the "License");
                <br />
                you may not use this file except in compliance with the License.
                <br />
                You may obtain a copy of the License at
                <br />
                <br />
                {`http://www.apache.org/licenses/LICENSE-2.0`}
                <br />
                <br />
                Unless required by applicable law or agreed to in writing, software
                <br />
                distributed under the License is distributed on an "AS IS" BASIS,
                <br />
                WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                <br />
                See the License for the specific language governing permissions and
                <br />
                limitations under the License.
                <br />
            </p>
        </div>
    </section>
)
// tslint:disable-next-line:max-file-line-count
